class HairQuestionnaire {
  constructor() {
    this.elements = {
      startBtn: document.getElementById("introduction-start-btn"),
      userConsent: document.getElementById("consent-yes"),
      // consentMail: document.getElementById("consent-mail"),
      nameInput: document.getElementById("name"),
      surnameInput: document.getElementById("surname"),
      introductionSection: document.querySelector(
        ".introduction-section__content"
      ),
      questionnaireSection: document.querySelector(".hair-questionnaire"),
      steps: document.querySelectorAll(".hair-questionnaire__step"),
      stepSections: document.querySelectorAll(
        ".hair-questionnaire__step-section"
      ),
      aboutYouNextBtn: document.querySelector(
        '[data-step="0"] [data-action="next"]'
      ),
      emailInput: document.querySelector(".hair-questionnaire__email"),
      dateOfBirthInput: document.querySelector(
        ".hair-questionnaire__date-of-birth"
      ),
      contactNumberInput: document.querySelector(
        ".hair-questionnaire__contact-number"
      ),
      marketingOptInCheckbox: document.getElementById("marketing-opt-in"),
      personalDetailsNextBtn: document.querySelector(
        '[data-step="6"] [data-action="next"]'
      ),
      conditionRange: document.getElementById("conditionRange"),
      currentConditionSpan: document.getElementById("currentCondition"),
      rangeValueDiv: document.querySelector(".hair-questionnaire__range-value"),
      resultsFirstNameElement: document.getElementById("resultsFirstName"),
      resultsTensionLabel: document.getElementById("resultsTensionLabel"),
      resultsTensionDescElement: document.getElementById("resultsTensionDesc"),
      resultsTensionNoteElement: document.getElementById("resultsTensionNote"),
      resultsHeatLabel: document.getElementById("resultsHeatLabel"),
      resultsHeatDescElement: document.getElementById("resultsHeatDesc"),
      resultsHeatNoteElement: document.getElementById("resultsHeatNote"),
      progressContainer: document.querySelector(
        ".hair-questionnaire__progress-container"
      ),
      marqueeContainer: document.querySelector(
        ".hair-questionnaire__marquee-container"
      ),
      scrollerLogo: document.querySelector(".scroller-logo"),
      resultsVideoContainer: document.getElementById("resultsVideoContainer"),
      productExtraClassSection: document.querySelector(
        ".product_questionnaire"
      ),
      resultsButton: document.querySelector(
        ".hair-questionnaire__results__button"
      ),
      progressBar: document.querySelector(".hair-questionnaire__progress-bar"),
      progressPercentage: document.querySelector(
        ".hair-questionnaire__progress-percentage"
      ),
      progressUsername: document.querySelector(
        ".hair-questionnaire__progress-username"
      ),
      temperatureURL:
        document.getElementById("resultsHeatDesc")?.dataset.thermometerIcon,
      tensionURL:
        document.getElementById("resultsTensionDesc")?.dataset.tensionIcon,
      errorMsg: document.querySelector(
        ".hair-questionnaire__email-error-message"
      ),
      whatsIncludedWrap: document.querySelector(".whats-included-wrap"),
      takeTheTestWrapper: document.querySelector(".takethetest-wrapper"),
      //slideWrapper: document.querySelectorAll(".banner-sec1 .slideshow"),
      slideoneWrapper: document.querySelector(
        ".shopify-section--image-carousel"
      ),
      slidetwoWrapper: document.querySelector(
        ".shopify-section--slideshow .section--flush"
      ),
      richWrapper: document.querySelectorAll(".custom-rich-text .section"),
      richoneWrapper: document.querySelector(
        "#shopify-section-template--24985884983681__rich_text_landing_KBc6eG .section"
      ),
      //swipeWrapper: document.querySelector('#shopify-section-template--24985884983681__image_carousel_fMTr8M .mySwiper'),
      swipebtmWrapper: document.querySelector(".mySwiper + .swiper-bottom"),
      imgWrapper: document.querySelector(".video-wrapper-slider"),
      landWrapper: document.querySelector(
        ".landing-media .section__color-wrapper"
      ),
      imgVidWrapper: document.querySelector(".image-video-wrapper-slider"),
      resImgWrapper: document.querySelector(".responsive-image-section"),
      reviewWrapper: document.querySelector(".vertical-breather"),
      faqWrapper: document.querySelector(
        ".shopify-section--faq .section__color-wrapper"
      ),
    };

    this.conditionLabels = [
      "Healthy and strong",
      "Average/ generally ok",
      "Thinning, very fragile, or prone to breakage",
    ];

    this.radioGroups = [
      {
        name: "hairType",
        selector: ".hair-questionnaire__hair-type__radio",
        nextBtn: '[data-step="1"] [data-action="next"]',
      },
      {
        name: "hairThickness",
        selector: ".hair-questionnaire__hair-thickness__radio",
        nextBtn: '[data-step="2"] [data-action="next"]',
      },
      {
        name: "hairTreatment",
        selector: ".hair-questionnaire__hair-treatment__radio",
        nextBtn: '[data-step="3"] [data-action="next"]',
      },
      {
        name: "hairStyle",
        selector: ".hair-questionnaire__hair-style__radio",
        nextBtn: '[data-step="5"] [data-action="next"]',
      },
      {
        name: "hairExtension",
        selector: ".hair-questionnaire__hair-extension__radio",
        nextBtn: null,
      },
    ];

    this.currentStep = 0;
    this.data =
      JSON.parse(sessionStorage.getItem("hairQuestionnaireData")) || {};

    this.heatDescriptions = {
      "190°C": {
        descriptions: [
          "Best for fine, fragile, or colour-treated hair",
          "Feels like 180°C — gentle yet effective",
        ],
        // notes:
        //   "Lowest heat for the most delicate cases. Pairs well with Setting II",
      },
      "200°C": {
        descriptions: [
          "Ideal for normal or occasionally treated hair",
          "Feels like 190°C* — balanced and versatile",
        ],
        // notes: "Balanced styling for everyday use.",
      },
      "210°C": {
        descriptions: [
          "For thick, healthy, or hard-to-style hair",
          "Feels like 200°C — powerful yet protective",
        ],
        // notes:
        //   "Highest power for resistant or thick strands — but still kinder due to Smart-Glide™.",
      },
    };

    this.tensionDescriptions = {
      "Setting II – Lighter Tension": {
        descriptions: [
          "Wider plate gap for reduced pull on delicate hair",
          "70% less tension thanks to Smart-Glide technology*",
          "Ideal for fragile, damaged, or hair with extensions",
        ],
        // notes:
        //   "Used only when hair is fragile or has extensions — regardless of strand thickness or chemical treatment.",
      },
      "Setting I – Firmer Tension": {
        descriptions: [
          "Closer plate gap for added control on healthier hair",
          "40% less tension thanks to Smart-Glide technology*",
          "Ideal for healthy or normal hair",
        ],
        // notes:
        //   "As long as hair condition is not fragile, this setting can be used safely — even on fine or coloured hair.",
      },
    };

    this.videoData = {
      "190°C_Setting II – Lighter Tension":
        "https://cdn.shopify.com/videos/c/o/v/074e1c248c3048ae9dd5184b44ed8dd3.mp4",
      "190°C_Setting I – Firmer Tension":
        "https://cdn.shopify.com/videos/c/o/v/6082580d6e414789b2401b59f081f603.mp4",
      "200°C_Setting II – Lighter Tension":
        "https://cdn.shopify.com/videos/c/o/v/b24662e64a284636a81cbcddcbf0454d.mp4",
      "200°C_Setting I – Firmer Tension":
        "https://cdn.shopify.com/videos/c/o/v/f9501973d62c44c98420ee9fb7f71df9.mp4",
      "210°C_Setting II – Lighter Tension":
        "https://cdn.shopify.com/videos/c/o/v/bcde98344c1249dd921176eb573fcb54.mp4",
      "210°C_Setting I – Firmer Tension":
        "https://cdn.shopify.com/videos/c/o/v/01d4d635d07a46f9950877b088583897.mp4",
    };

    this.listId = "S5CXNT";
    this.subscribeUrl =
      "https://manage.kmail-lists.com/ajax/subscriptions/subscribe";
  }

  saveData() {
    sessionStorage.setItem("hairQuestionnaireData", JSON.stringify(this.data));
  }

  goToStep(offset) {
    const newStep = this.currentStep + offset;
    if (newStep >= 0 && newStep < this.elements.stepSections.length) {
      this.currentStep = newStep;
      this.updateStepVisibility();
      this.updateProgressSteps();
      if (this.currentStep === this.elements.stepSections.length - 1) {
        this.handleResults();
      } else if (this.currentStep === 7) {
        this.animateProgressBar();
      }
    }
  }

  updateStepVisibility() {
    this.elements.stepSections.forEach((section, i) => {
      section.style.display = i === this.currentStep ? "block" : "none";
    });
    [this.elements.marqueeContainer, this.elements.progressContainer].forEach(
      (container) => {
        if (container) {
          container.style.display = this.currentStep === 7 ? "none" : "";
        }
      }
    );
  }

  updateProgressSteps() {
    this.elements.steps.forEach((step, i) => {
      step.classList.remove(
        "hair-questionnaire__step--active",
        "hair-questionnaire__step--completed"
      );
      if (i < this.currentStep) {
        step.classList.add("hair-questionnaire__step--completed");
      } else if (i === this.currentStep) {
        step.classList.add("hair-questionnaire__step--active");
      }
    });

    if (this.currentStep === 0 || this.currentStep === 6) {
      this.elements.questionnaireSection.classList.add(
        "hair-questionnaire--active"
      );
    } else {
      this.elements.questionnaireSection.classList.remove(
        "hair-questionnaire--active"
      );
    }

    if (this.currentStep === this.elements.steps.length - 1) {
      const lastStep = this.elements.steps[this.currentStep];
      lastStep.classList.add("hair-questionnaire__step--completed");
      lastStep.classList.remove("hair-questionnaire__step--active");
    }

    if (this.elements.productExtraClassSection) {
      const shouldShow = this.currentStep === 8;
      this.elements.productExtraClassSection.style.display = shouldShow
        ? "block"
        : "none";
      if (this.elements.whatsIncludedWrap) {
        this.elements.whatsIncludedWrap.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.takeTheTestWrapper) {
        this.elements.takeTheTestWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      // this.elements.slideWrapper.forEach((el) => {
      //   el.style.display = shouldShow ? "block" : "none";
      // });
      if (this.elements.slideoneWrapper) {
        this.elements.slideoneWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.slidetwoWrapper) {
        this.elements.slidetwoWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      this.elements.richWrapper.forEach((el) => {
        el.style.display = shouldShow ? "block" : "none";
      });
      if (this.elements.richoneWrapper) {
        this.elements.richoneWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      // if (this.elements.swipeWrapper) {
      //   this.elements.swipeWrapper.style.display = shouldShow
      //     ? "block"
      //     : "none";
      // }
      if (this.elements.swipebtmWrapper) {
        this.elements.swipebtmWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.imgWrapper) {
        this.elements.imgWrapper.style.display = shouldShow ? "block" : "none";
      }
      if (this.elements.landWrapper) {
        this.elements.landWrapper.style.display = shouldShow ? "block" : "none";
      }
      if (this.elements.imgVidWrapper) {
        this.elements.imgVidWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.resImgWrapper) {
        this.elements.resImgWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.reviewWrapper) {
        this.elements.reviewWrapper.style.display = shouldShow
          ? "block"
          : "none";
      }
      if (this.elements.faqWrapper) {
        this.elements.faqWrapper.style.display = shouldShow ? "block" : "none";
      }

      if (shouldShow) {
        $(this.elements.productExtraClassSection)
          .find(".slick-slider")
          .slick("refresh");
      }
    }
  }

  updateConditionDisplay(value) {
    const index = parseInt(value, 10);
    const label = this.conditionLabels[index];
    const percentage = (index / (this.conditionLabels.length - 1)) * 100;

    this.elements.currentConditionSpan.textContent = label;
    this.elements.rangeValueDiv.style.left = `${percentage}%`;
    this.elements.conditionRange.style.setProperty(
      "--range-progress",
      `${percentage}%`
    );

    this.data.hairCondition = label;
  }

  updateStartButtonState() {
    this.elements.startBtn.disabled = !this.elements.userConsent.checked;
  }

  updateAboutYouNextButtonState() {
    const filled =
      this.elements.nameInput.value.trim() &&
      this.elements.surnameInput.value.trim();
    this.elements.aboutYouNextBtn.disabled = !filled;
  }

  updateRadioGroupState(group) {
    const radios = document.querySelectorAll(group.selector);
    let selected = false;

    radios.forEach((radio) => {
      const card = radio.closest(".hair-questionnaire__card");
      if (radio.checked) {
        card.classList.add("hair-questionnaire__card--selected");
        this.data[group.name] = radio.value;
        selected = true;
      } else {
        card.classList.remove("hair-questionnaire__card--selected");
      }
    });

    if (group.nextBtn) {
      document.querySelector(group.nextBtn).disabled = !selected;
    }
  }

  updatePersonalDetailsNextState() {
    const emailValue = this.elements.emailInput.value.trim();
    const isEmailValid = this.validateEmail(emailValue);
    if (emailValue && !isEmailValid) {
      this.elements.errorMsg.style.display = "block";
    } else {
      this.elements.errorMsg.style.display = "none";
    }
    const valid =
      isEmailValid &&
      this.elements.marketingOptInCheckbox.checked &&
      this.elements.dateOfBirthInput.value.trim() &&
      this.elements.contactNumberInput.value.trim();

    this.elements.personalDetailsNextBtn.disabled = !valid;
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  animateProgressBar() {
    let width = 0;
    const duration = 4000;
    const start = performance.now();
    const frame = (time) => {
      const elapsed = time - start;
      const progress = Math.min(elapsed / duration, 1);
      width = progress * 100;

      if (this.elements.progressBar) {
        this.elements.progressBar.style.width = `${width}%`;
      }
      if (this.elements.progressPercentage) {
        this.elements.progressPercentage.textContent = `${Math.round(width)}%`;
      }

      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        setTimeout(() => {
          this.goToStep(1);
        }, 1000);
      }
    };
    requestAnimationFrame(frame);
  }

  handleResults() {
    if (this.elements.resultsFirstNameElement && this.data.firstName) {
      this.elements.resultsFirstNameElement.innerHTML = `<span>${this.data.firstName}</span>, here's your trichologist-approved match.`;
    }

    [this.elements.progressContainer, this.elements.marqueeContainer].forEach(
      (el) => {
        if (el) el.style.display = "none";
      }
    );

    if (this.elements.resultsButton) {
      this.elements.resultsButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (this.elements.productExtraClassSection) {
          const offset = 66;
          const elementPosition =
            this.elements.productExtraClassSection.getBoundingClientRect().top +
            window.pageYOffset;
          const offsetPosition = elementPosition - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    }

    let heatScore = 0;
    if (this.data.hairThickness === "fine") heatScore++;
    if (this.data.hairTreatment === "Yes, regularly") heatScore++;
    if (
      this.data.hairCondition === "Thinning, very fragile, or prone to breakage"
    )
      heatScore++;

    let heat = "200°C";
    if (heatScore >= 2) {
      heat = "190°C";
    } else if (
      this.data.hairThickness === "thick" &&
      this.data.hairCondition === "Healthy and strong" &&
      this.data.hairTreatment === "no"
    ) {
      heat = "210°C";
    }

    let tension = "";
    if (
      this.data.hairCondition ===
        "Thinning, very fragile, or prone to breakage" ||
      this.data.hairExtension === "yes"
    ) {
      tension = "Setting II – Lighter Tension";
    } else {
      tension = "Setting I – Firmer Tension";
    }

    Object.assign(this.data, { heat, tension });
    this.saveData();

    const { email, firstName, contactNumber } = this.data;

    this.subscribeUser({
      email,
      firstName,
      heat,
      tension,
      contactNumber,
    });

    if (this.elements.resultsHeatLabel) {
      this.elements.resultsHeatLabel.textContent = heat;
    }

    if (this.elements.resultsHeatDescElement && this.heatDescriptions[heat]) {
      this.elements.resultsHeatDescElement.innerHTML = this.heatDescriptions[
        heat
      ].descriptions
        .map(
          (desc) =>
            `<li>
              <img src="${this.elements.temperatureURL}" alt="Thermometer" />
              <span>${desc}</span>
            </li>`
        )
        .join("<br/>");
    }

    if (this.elements.resultsHeatNoteElement && this.heatDescriptions[heat]) {
      this.elements.resultsHeatNoteElement.textContent =
        this.heatDescriptions[heat].notes;
    }

    if (this.elements.resultsTensionLabel) {
      this.elements.resultsTensionLabel.textContent = tension;
    }

    if (
      this.elements.resultsTensionDescElement &&
      this.tensionDescriptions[tension]
    ) {
      this.elements.resultsTensionDescElement.innerHTML =
        this.tensionDescriptions[tension].descriptions
          .map((desc) => {
            if (desc.startsWith("Ideal for")) {
              return `&rarr; ${desc}`;
            }
            return `<li>
                      <img src="${this.elements.tensionURL}" alt="Tension" />
                      <span>${desc}</span>
                    </li>`;
          })
          .join("<br/>");
    }

    if (
      this.elements.resultsTensionNoteElement &&
      this.tensionDescriptions[tension]
    ) {
      this.elements.resultsTensionNoteElement.textContent =
        this.tensionDescriptions[tension].notes;
    }

    const videoKey = `${heat}_${tension}`;
    if (this.elements.resultsVideoContainer && this.videoData[videoKey]) {
      this.elements.resultsVideoContainer.innerHTML = `<video autoplay loop muted playsinline src="${this.videoData[videoKey]}" data-videokey="${videoKey}"></video>`;
    }
  }

  subscribeUser({ email, firstName, heat, tension, contactNumber }) {
    const data = new URLSearchParams();

    data.append("g", this.listId);
    data.append("email", email);
    data.append("first_name", firstName);
    data.append("heat", heat);
    data.append("tension", tension);
    data.append("$fields", "$source");
    data.append("$source", "Hair Questionnaire");
    // console.log('Klaviyo data' + data);
    console.log("name", firstName);
    console.log("email", email);
    fetch(this.subscribeUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
      },
      body: data,
    })
      .then((response) => response.json())
      .then((responseData) => {
        console.log("Klaviyo subscribe response:", responseData);
        if (responseData.success) {
          this.identifyUser({ email, firstName, heat, tension, contactNumber });
          const normalizedFirstName = firstName.trim().toLowerCase();
          const hashedFirstName = sha256(normalizedFirstName);
          const normalized = email.trim().toLowerCase();
          const hashedEmail = sha256(normalized);
          console.log("hashedEmail",hashedEmail);
          console.log("hashedFirstName",hashedFirstName);
          console.log('firstName:', firstName);

          fbq('trackCustom', 'QuizCompleted', {
            fn: hashedFirstName,
            em: hashedEmail,
          });
          console.log('Meta Pixel event fired for QuizCompleted');
        } else {
          console.error("Klaviyo subscription failed:", responseData.errors);
        }
      })
      .catch((error) => {
        console.error("Error subscribing to Klaviyo list:", error);
      });
  }

  identifyUser({ email, firstName, heat, tension, contactNumber }) {
    let abandon = true;
    // console.log('identiyfyUser' + email + heat + firstName + tension);
    if (window._learnq) {
      window._learnq.push([
        "identify",
        {
          $email: email,
          $first_name: firstName,
          $phone_number: contactNumber,
          heat,
          tension,
          abandon,
        },
      ]);
    }
  }

  attachEventListeners() {
    this.elements.userConsent?.addEventListener(
      "change",
      this.updateStartButtonState.bind(this)
    );
    this.elements.startBtn?.addEventListener("click", () => {
      if (!this.elements.startBtn.disabled) {
        this.elements.introductionSection.style.display = "none";
        this.elements.scrollerLogo &&
          (this.elements.scrollerLogo.style.display = "none");
        this.elements.questionnaireSection.style.display = "block";
        this.data.userConsentAccepted = this.elements.userConsent.checked;
        // this.data.emailMarketingConsent = this.elements.consentMail.checked;
        this.saveData();
      }
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    this.elements.aboutYouNextBtn?.addEventListener("click", () => {
      this.data.firstName = this.elements.nameInput.value;
      this.data.lastName = this.elements.surnameInput.value;
      this.saveData();
    });

    document.querySelectorAll('[data-action="next"]').forEach((btn) =>
      btn.addEventListener("click", () => {
        if (
          this.currentStep === 6 &&
          !this.elements.personalDetailsNextBtn.disabled
        ) {
          Object.assign(this.data, {
            email: this.elements.emailInput.value,
            dateOfBirth: this.elements.dateOfBirthInput.value,
            contactNumber: this.elements.contactNumberInput.value,
            marketingOptInAccepted:
              this.elements.marketingOptInCheckbox.checked,
          });
          if (this.elements.progressUsername && this.data.firstName) {
            this.elements.progressUsername.textContent = `${this.data.firstName},`;
          }
        }
        this.saveData();
        this.goToStep(1);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      })
    );

    document.querySelectorAll('[data-action="back"]').forEach((btn) =>
      btn.addEventListener("click", () => {
        this.goToStep(-1);
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      })
    );

    [this.elements.nameInput, this.elements.surnameInput].forEach((input) => {
      input?.addEventListener(
        "input",
        this.updateAboutYouNextButtonState.bind(this)
      );
    });

    this.elements.emailInput?.addEventListener(
      "input",
      this.updatePersonalDetailsNextState.bind(this)
    );
    this.elements.marketingOptInCheckbox?.addEventListener(
      "change",
      this.updatePersonalDetailsNextState.bind(this)
    );
    this.elements.dateOfBirthInput?.addEventListener(
      "input",
      this.updatePersonalDetailsNextState.bind(this)
    );
    this.elements.contactNumberInput?.addEventListener(
      "input",
      this.updatePersonalDetailsNextState.bind(this)
    );

    this.radioGroups.forEach((group) => {
      document.querySelectorAll(group.selector).forEach((radio) => {
        radio.addEventListener("change", () =>
          this.updateRadioGroupState(group)
        );
      });
    });

    if (this.elements.conditionRange) {
      this.elements.conditionRange.addEventListener("input", (event) =>
        this.updateConditionDisplay(event.target.value)
      );

      ["resize", "load"].forEach((evt) => {
        window.addEventListener(evt, () =>
          this.updateConditionDisplay(this.elements.conditionRange.value)
        );
      });
    }
  }

  init() {
    this.attachEventListeners();
    this.updateStartButtonState();
    this.updateAboutYouNextButtonState();
    this.updateStepVisibility();
    this.updateProgressSteps();
    this.radioGroups.forEach((group) => this.updateRadioGroupState(group));
    this.applyStoredConditionValue();
  }

  applyStoredConditionValue() {
    if (this.elements.conditionRange) {
      const value = this.conditionLabels.indexOf(this.data.hairCondition || "");
      this.elements.conditionRange.value = value >= 0 ? value : 0;
      this.updateConditionDisplay(this.elements.conditionRange.value);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const questionnaire = new HairQuestionnaire();
  questionnaire.init();
});
